export default {
  agentContact: "agentContact",
  error: "error",
  success: "success"
};
